import styled from "@emotion/styled"
import { animated } from "react-spring"

import { rhythm } from "@utils/typography"

const Slide = styled(animated.div)`
  background-size: cover;
  background-position: center;
  bottom: 0;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  will-change: opacity;
`

const Wrapper = styled.div`
  display: grid;
  grid-gap: ${rhythm(1)};
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-rows: auto auto;
  padding: 0 ${rhythm(1)};
  margin: ${rhythm(1)} auto;
  max-width: 1400px;

  & > div {
    position: relative;
  }

  & > div:first-of-type {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
    ${props => props.theme.mq[2]} {
      height: 650px;
    }
    height: 250px;
  }

  & > div:last-child {
    grid-column: 2 / span 2;
    grid-row: 2 / span 1;
  }
`

export { Slide, Wrapper }
